/*
  React Flow Constants

  This module defines constants used for React Flow transformation,
  including node type labels and default styling.
*/

/**
 * Human-readable labels for node types
 * Used when a node doesn't have a specific name
 */
export const NODE_TYPE_LABELS: Record<string, string> = {
  start: 'Start',
  outcome: 'Outcome',
  workflow: 'Workflow',
  start_router: 'Start Router',
  source_workflow: 'Source Workflow',
  reconciliation_workflow: 'Reconciliation',
  action: 'Action',
  review: 'Review',
  retry: 'Retry',
  resume: 'Resume',
  addNodeForm: 'Add Node',
} as const;

/**
 * Default edge styling
 */
export const DEFAULT_EDGE_STYLE = {
  strokeWidth: 1.5,
  stroke: '#d1d5db',
} as const;

/**
 * Edge label styling
 */
export const EDGE_LABEL_STYLE = {
  fontSize: '10px',
  fontWeight: '400',
  fill: '#6b7280',
  backgroundColor: 'transparent',
  padding: '0px',
  border: 'none',
} as const;

/**
 * Edge label background styling
 */
export const EDGE_LABEL_BG_STYLE = {
  fill: 'transparent',
} as const;

/**
 * Special edge styles for workflow outcome options
 */
export const WORKFLOW_OUTCOME_EDGE_STYLES = {
  alert: {
    stroke: '#ef4444',
    strokeDasharray: '5,5',
  },
  investigation: {
    stroke: '#f59e0b',
  },
} as const;

